import { useState } from 'react';
import './AdminPortal.css';

const MODULES = [
  {
    id:'recruitment', icon:'💼', title:'Recruitment Module',
    items:['Post a Job with custom JD','Manage all applications in one view','Workflow automation per role','Recruiter & hiring manager assignments','Application status tracking'],
    color:'#8b5cf6',
  },
  {
    id:'assessment', icon:'🧠', title:'Assessment Engine',
    items:['AI-powered test builder','Aptitude, coding & technical MCQs','Adaptive difficulty per candidate','Anti-cheat & proctoring controls','Auto-grading with score analytics'],
    color:'#a78bfa',
  },
  {
    id:'analytics', icon:'📊', title:'Analytics & Dashboards',
    items:['Overview: tests, invited, attempted, pass rate','Recruiter Analytics: team pipeline view','Job Analytics: per-role hiring funnel','Pass vs Fail donut charts','Top test types by attempt count'],
    color:'#7c3aed',
  },
  {
    id:'team', icon:'👥', title:'Team Management',
    items:['Candidate Hub — all candidates centralised','Resume Library — searchable talent pool','User Library — role-based access control','Wallet — billing and usage tracking','Audit logs for all admin actions'],
    color:'#6d28d9',
  },
  {
    id:'workflow', icon:'🔄', title:'Workflows & Automation',
    items:['Custom hiring stages per role','Auto-advance candidates on score thresholds','Interview scheduling from admin panel','Offer management & acceptance tracking','SLA alerts for delayed stages'],
    color:'#5b21b6',
  },
  {
    id:'config', icon:'⚙️', title:'Configuration & Settings',
    items:['Role & permission management','Department and team structure','Notification templates & triggers','Branding per portal','Global default configurations'],
    color:'#4c1d95',
  },
];

export default function AdminPortal() {
  const [active, setActive] = useState('recruitment');
  const mod = MODULES.find(m => m.id === active);

  return (
    <section id="admin" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">Admin Portal</span>
        <h2 className="sec-title">Command Centre for Recruiters.</h2>
        <p className="sec-sub" style={{marginBottom:'3rem'}}>
          The VERDICT Admin Portal gives hiring teams complete control over jobs, candidates,
          assessments, analytics, and workflows — in a single purple-powered console.
        </p>

        {/* Animated admin portal visual */}
        <div className="admin-showcase">
          <div className="admin-nav-pills">
            {MODULES.map(m => (
              <button
                key={m.id}
                className={`admin-pill ${active === m.id ? 'admin-pill--active' : ''}`}
                onClick={() => setActive(m.id)}
                style={{'--pc': m.color}}
              >
                <span>{m.icon}</span> {m.title.split(' ')[0]}
              </button>
            ))}
          </div>

          <div className="admin-detail" style={{'--dc': mod.color}}>
            <div className="admin-detail__header">
              <div className="admin-detail__icon">{mod.icon}</div>
              <div>
                <h3 className="admin-detail__title">{mod.title}</h3>
                <p className="admin-detail__sub">Part of the VERDICT Admin Portal</p>
              </div>
              <div className="admin-detail__badge">Live</div>
            </div>
            <div className="admin-detail__features">
              {mod.items.map((item, i) => (
                <div key={i} className="admin-feature-row">
                  <div className="admin-feature-check">✓</div>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Decorative metrics panel */}
          <div className="admin-metrics-panel">
            <div className="amp-title">Live Snapshot</div>
            {[
              {label:'Total Recruiters', val:'12', icon:'👤'},
              {label:'Open Jobs',        val:'11', icon:'💼'},
              {label:'Applications',     val:'3',  icon:'📋'},
              {label:'Hired',            val:'0',  icon:'🎉'},
            ].map(m => (
              <div key={m.label} className="amp-row">
                <span className="amp-icon">{m.icon}</span>
                <div className="amp-info">
                  <div className="amp-val">{m.val}</div>
                  <div className="amp-label">{m.label}</div>
                </div>
              </div>
            ))}

            {/* Candidate pipeline */}
            <div className="amp-pipeline">
              <div className="amp-pipe-title">Candidate Pipeline</div>
              {[
                {stage:'Applied',   val:1, pct:100},
                {stage:'Screened',  val:0, pct:0},
                {stage:'Interview', val:0, pct:0},
                {stage:'Offer',     val:0, pct:0},
                {stage:'Hired',     val:0, pct:0},
              ].map(p => (
                <div key={p.stage} className="pipeline-row">
                  <span className="pipeline-stage">{p.stage}</span>
                  <div className="pipeline-track">
                    <div className="pipeline-fill" style={{width:`${p.pct || 5}%`}} />
                  </div>
                  <span className="pipeline-val">{p.val}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
